/**
 * recordOwnership — "does this player own this jukebox record" for the
 * JukeboxDrawer picker. Mirrors ../tavern/decorOwnership.ts's three-signal
 * union, scoped to the `record-*` catalog family:
 *   1. `DEFAULT_RECORD_IDS` — the 3 free records everyone can request.
 *   2. `source.kind === 'achievement'` — cross-checked against
 *      CharacterStats.achievements.
 *   3. The /stats inventory's `records` bucket — embers-shop purchases.
 */
import { getCosmetic } from '@tt/lobby/cosmetics-catalog';
import { RECORDS, DEFAULT_RECORD_IDS } from '@tt/lobby/records';

/** Every record (bare semantic id) this player owns, from all three signals.
 *  `inventory` is the /stats inventory object; the `records` bucket reads
 *  defensively so a pre-fix cached response degrades to signals 1+2. */
export function computeOwnedRecordIds(
  achievementCodes: ReadonlySet<string>,
  inventory?: Record<string, unknown>,
): Set<string> {
  const owned = new Set<string>(DEFAULT_RECORD_IDS);
  const arr = inventory?.records;
  if (Array.isArray(arr)) for (const v of arr) if (typeof v === 'string') owned.add(v);
  for (const r of RECORDS) {
    const cat = getCosmetic(`record-${r.id}`);
    if (cat?.source.kind === 'achievement' && achievementCodes.has(cat.source.id)) owned.add(r.id);
  }
  return owned;
}
